const EMPTY_UNIT_GROUP_KEY = '\0__empty_unit__';
const EMPTY_PUBLISHER_BLOCK_KEY = '\0__empty_publisher_block__';

/** 출판사 열 기준 연속 블록 ID — 빈 칸은 직전 출판사 블록에 포함 */
export function resolvePublisherBlockKeys(publisherTexts: string[]): string[] {
  let blockId = 0;
  let runningPublisher = '';
  return publisherTexts.map((raw) => {
    const explicit = (raw ?? '').trim();
    if (explicit) {
      if (explicit !== runningPublisher) {
        blockId += 1;
        runningPublisher = explicit;
      }
    }
    if (blockId === 0) return EMPTY_PUBLISHER_BLOCK_KEY;
    return `pb:${blockId}:${runningPublisher}`;
  });
}

/** 단원명에서 차시 카운트 그룹 키 — 구분기호 앞(대단원) 또는 단원 전체 */
export function unitGroupKeyForLessonCount(unitText: string, delimiter: string): string {
  const t = unitText.trim();
  if (!t) return EMPTY_UNIT_GROUP_KEY;
  const d = delimiter ?? '';
  if (!d.length) return t;
  const idx = t.indexOf(d);
  if (idx >= 0) {
    const head = t.slice(0, idx).trim();
    return head || t;
  }
  return t;
}

export type LessonCountAssignment = { current: number; total: number };

/** 행 순서대로 해당차시·전체차시 번호 — 단원이 비어 있으면 null */
export function computeLessonCountAssignments(
  unitTexts: string[],
  delimiter: string,
  publisherTexts?: string[]
): Array<LessonCountAssignment | null> {
  const publisherBlocks =
    publisherTexts && publisherTexts.length === unitTexts.length
      ? resolvePublisherBlockKeys(publisherTexts)
      : null;
  const groupKeys = unitTexts.map((u, idx) => {
    const unitKey = unitGroupKeyForLessonCount(u, delimiter);
    if (unitKey === EMPTY_UNIT_GROUP_KEY) return EMPTY_UNIT_GROUP_KEY;
    if (!publisherBlocks) return unitKey;
    const pb = publisherBlocks[idx];
    if (pb === EMPTY_PUBLISHER_BLOCK_KEY) return EMPTY_UNIT_GROUP_KEY;
    return `${pb}\0${unitKey}`;
  });
  const countsByGroup = new Map<string, number>();
  groupKeys.forEach((gk) => {
    if (gk === EMPTY_UNIT_GROUP_KEY) return;
    countsByGroup.set(gk, (countsByGroup.get(gk) ?? 0) + 1);
  });
  const indexInGroup = new Map<string, number>();
  return unitTexts.map((_u, idx) => {
    const gk = groupKeys[idx];
    if (gk === EMPTY_UNIT_GROUP_KEY) return null;
    const total = countsByGroup.get(gk) ?? 1;
    const nextIdx = (indexInGroup.get(gk) ?? 0) + 1;
    indexInGroup.set(gk, nextIdx);
    return { current: nextIdx, total };
  });
}
